import React, { useRef, useCallback, useContext, } from "react";
import { Form, RadioGroup, RequiredValidator, Button, Card, } from "@lysaab/ui-2";
import { PepType, PepContext, EntityType } from "../PepContext";
import { useIntl, FormattedMessage } from "react-intl";
import { messages } from "./IsPepMessages";
export const IsPepQuestion = ({ ownerName, entityType, type, onChange, resetValues, }) => {
    const intl = useIntl();
    const IsPepAlternatives = [
        {
            text: intl.formatMessage(messages[PepType.NOT_PEP], {
                entityType,
                name: ownerName,
            }),
            value: PepType.NOT_PEP,
        },
        {
            text: intl.formatMessage(messages[PepType.ME], {
                entityType,
                name: ownerName,
            }),
            value: PepType.ME,
        },
        {
            text: intl.formatMessage(messages[PepType.RELATIVE], {
                entityType,
                name: ownerName,
            }),
            value: PepType.RELATIVE,
        },
        {
            text: intl.formatMessage(messages[PepType.COLLEAGUE], {
                entityType,
                name: ownerName,
            }),
            value: PepType.COLLEAGUE,
        },
    ];
    return (React.createElement(RadioGroup, { alternatives: IsPepAlternatives, onChange: (alternative) => {
            onChange(alternative.value);
            resetValues === null || resetValues === void 0 ? void 0 : resetValues();
        }, value: IsPepAlternatives.find((alt) => alt.value === type), header: intl.formatMessage(messages.header, {
            entityType,
            name: ownerName,
        }), validators: [
            new RequiredValidator(intl.formatMessage(messages.required)),
        ], "data-test-id": "pep-ispep" }));
};
export const IsPepPage = ({ next }) => {
    const pepContext = useContext(PepContext);
    const formRef = useRef();
    const nextPage = useCallback(() => {
        if (formRef.current && formRef.current.isValid) {
            next();
        }
    }, [formRef, next]);
    return (React.createElement(Form, { onSubmit: nextPage, lysaFormRef: formRef },
        React.createElement(Card, null,
            React.createElement(IsPepQuestion, { ownerName: pepContext.state.ownerName, entityType: pepContext.state.legalEntityType || EntityType.PERSON, type: pepContext.state.type, onChange: (type) => pepContext.setState({ type }) })),
        React.createElement(Button, { label: React.createElement(FormattedMessage, { id: "pep.ispep.next" }), block: true, type: "submit" })));
};
